import { useContext } from 'react';
import { SocketContext } from 'common/context/socket/socket.context';

export const useSocketContext = () => useContext(SocketContext);
